import useTranslation from 'hooks/useTranslation'
import { useEffect, useState } from 'react'

const MESSAGES = [
  'secure',
  'reliable',
  'convenient',
]
const MESSAGE_LENGTH = MESSAGES.length

const SplashMessage = () => {
  const [index, setIndex] = useState(0)
  const { t } = useTranslation('splashScreen')

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(i => (i + 1) % MESSAGE_LENGTH)
    }, 1000)
    return () => {
      clearInterval(interval)
    }
  }, [])

  return (
    <div className='splash__message'>
      #{t(MESSAGES[index])}
    </div>
  )
}

export default SplashMessage